export default function Home() {
    return (
        <div className="pt-36 bg-gray-100 ">

            <div className="container grid place-items-center items-center">
                <div className="relative">
                    <input type="text" className="h-14 w-96 pl-10 pr-20 rounded-lg z-0 focus:shadow focus:outline-none" placeholder="Search discussions..." />
                    <div className="absolute top-2 right-2"> <button className="h-10 w-20 text-white rounded-lg bg-red-500 hover:bg-red-600">Search</button>
                    </div>
                </div>
            </div>

            <div className="flex items-center w-full justify-center my-4">
                <button className="h-10 w-20 mx-8 text-white rounded-lg bg-red-500 hover:bg-red-600">Tags</button>
                <button className="h-10 w-20 mx-8 text-white rounded-lg bg-red-500 hover:bg-red-600">Tags</button>
                <button className="h-10 w-20 mx-8 text-white rounded-lg bg-red-500 hover:bg-red-600">Tags</button>
                <button className="h-10 w-20 mx-8 text-white rounded-lg bg-red-500 hover:bg-red-600">Tags</button>
                <button className="h-10 w-20 mx-8 text-white rounded-lg bg-red-500 hover:bg-red-600">Tags</button>
                <button className="h-10 w-20 mx-8 text-white rounded-lg bg-red-500 hover:bg-red-600">Tags</button>
            </div>

            <div class="flex items-center justify-center min-h-screen p-10">
                <div class="grid md:grid-cols-2 grid-cols-1 gap-2 max-w-6xl">

                    <main class="flex items-center p-10 w-full h-full bg-white">
                        <div class="border-t border-b pt-16 grid grid-cols-2 gap-8">
                            <div class="flex flex-col justify-start">
                                <div class="flex flex-col w-full object-cover h-4/6 justify-items-start border rounded-lg overflow-hidden"
                                    style={{ minHeigth: "320px" }}>
                                    <img class="w-full h-full object-cover" src='https://images.unsplash.com/photo-1515955656352-a1fa3ffcd111?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80' alt='nike shoes' />
                                </div>
                            </div>
                            <div class="flex flex-col">
                                <div class="flex flex-col gap-4">
                                    <h1 class="capitalize text-4xl font-extrabold">Roomname</h1>
                                    <p class="text-lg text-gray-500	">Description.</p>
                                    <div class="flex items-center gap-4 my-6 cursor-pointer ">
                                        <div class="bg-blue-600 px-5 py-3 text-white rounded-lg  text-center">Enter room</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>

                    <main class="flex items-center p-10 w-full h-full bg-white">
                        <div class="border-t border-b pt-16 grid grid-cols-2 gap-8">
                            <div class="flex flex-col justify-start">
                                <div class="flex flex-col w-full object-cover h-4/6 justify-items-start border rounded-lg overflow-hidden"
                                    style={{ minHeigth: "320px" }}>
                                    <img class="w-full h-full object-cover" src='https://images.unsplash.com/photo-1515955656352-a1fa3ffcd111?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80' alt='nike shoes' />
                                </div>
                            </div>
                            <div class="flex flex-col">
                                <div class="flex flex-col gap-4">
                                    <h1 class="capitalize text-4xl font-extrabold">Roomname</h1>
                                    <p class="text-lg text-gray-500	">Description.</p>
                                    <div class="flex items-center gap-4 my-6 cursor-pointer ">
                                        <div class="bg-blue-600 px-5 py-3 text-white rounded-lg  text-center">Enter room</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>

                    <main class="flex items-center p-10 w-full h-full bg-white">
                        <div class="border-t border-b pt-16 grid grid-cols-2 gap-8">
                            <div class="flex flex-col justify-start">
                                <div class="flex flex-col w-full object-cover h-4/6 justify-items-start border rounded-lg overflow-hidden"
                                    style={{ minHeigth: "320px" }}>
                                    <img class="w-full h-full object-cover" src='https://images.unsplash.com/photo-1515955656352-a1fa3ffcd111?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80' alt='nike shoes' />
                                </div>
                            </div>
                            <div class="flex flex-col">
                                <div class="flex flex-col gap-4">
                                    <h1 class="capitalize text-4xl font-extrabold">Roomname</h1>
                                    <p class="text-lg text-gray-500	">Description.</p>
                                    <div class="flex items-center gap-4 my-6 cursor-pointer ">
                                        <div class="bg-blue-600 px-5 py-3 text-white rounded-lg  text-center">Enter room</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>

                    <main class="flex items-center p-10 w-full h-full bg-white">
                        <div class="border-t border-b pt-16 grid grid-cols-2 gap-8">
                            <div class="flex flex-col justify-start">
                                <div class="flex flex-col w-full object-cover h-4/6 justify-items-start border rounded-lg overflow-hidden"
                                    style={{ minHeigth: "320px" }}>
                                    <img class="w-full h-full object-cover" src='https://images.unsplash.com/photo-1515955656352-a1fa3ffcd111?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80' alt='nike shoes' />
                                </div>
                            </div>
                            <div class="flex flex-col">
                                <div class="flex flex-col gap-4">
                                    <h1 class="capitalize text-4xl font-extrabold">Roomname</h1>
                                    <p class="text-lg text-gray-500	">Description.</p>
                                    <div class="flex items-center gap-4 my-6 cursor-pointer ">
                                        <div class="bg-blue-600 px-5 py-3 text-white rounded-lg  text-center">Enter room</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>

                </div>

            </div>

        </div>
    )
}
